import { warnLogMessage } from "@/api/electricSence";
let state = {
  Message: 1
};
const getters = {
  getselectList(state) {
    return state.Message;
  }
};
const mutations = {
  REQ_MESSAGE(state, payload) {
    state.Message = payload;
  }
};
const actions = {
  ActionwarnLogMessage({ commit }) {
    warnLogMessage().then(res => {
      if (res.data.code == 200) {
        commit("REQ_MESSAGE", res.data.data);
      }
    });
  }
};
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
